<template>
    <b-tooltip v-if="icon" :label="label" position="is-bottom" type="is-dark">
        <b-icon style="margin-left: 0"
            :icon="icon">
        </b-icon>
    </b-tooltip>
</template>

<script>
import { BUILD_TYPES } from "@/utils/constants";

export default {
    name: "BuildTriggerTypeIcon",
    props: {
        type: [Number, String],
    },
    computed: {
        icon() {
            switch(this.type) {
                case BUILD_TYPES.MANUAL.id:
                    return 'account';
                case BUILD_TYPES.CHANGES.id:
                    return 'git';
                case BUILD_TYPES.TIMER.id:
                    return 'av-timer';
                default:
                    return null;
            }
        },
        label() {
            const buildType = Object.values(BUILD_TYPES).find(item => item.id.toString() === this.type.toString());
            if (buildType) {
                return buildType.title;
            } else {
                return 'Unknown';
            }
        }
    }
}
</script>

<style scoped>

</style>